import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { BaaScrollContainerComponent } from '../baa-scroll-container';

@Component({
  selector: 'lib-baa-request-sent-success',
  standalone: true,
  imports: [TranslateModule, SvgIconComponent, BaaScrollContainerComponent],
  templateUrl: './baa-request-sent-success.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaRequestSentSuccessComponent {
  public readonly signerFullName = input.required<string>();
  public readonly signerEmail = input.required<string>();
  public readonly done = output<void>();

  protected onDone(): void {
    this.done.emit();
  }
}
